// Keep in sync with api/middleware/auth.ts (backend).
// 'expert-manager' = "תמיכה טכנית" (GH-724/735): experts, expert categories, support circles, onboarding notes, lectures, service bank, VOD.
// 'business-admin' = "מנהלת עסקית" (GH-735): companies, members, experts, lectures, service bank.
export type ROLE =
	| 'admin'
	| 'superadmin'
	| 'editor'
	| 'user'
	| 'guest'
	| 'business-admin'
	| 'group-sessions-viewer'
	| 'expert-manager';

/** Roles that only ever see a handful of screens: no dashboard, minimal menu. */
export const NARROW_ROLES: ROLE[] = ['expert-manager'];
